// Shared validation + styling for the name + email signup forms used by both
// the Home waitlist (WaitlistButton) and the News newsletter (NewsSubscribeButton).
// Keeping this in one place means both forms validate identically and a unit
// test can pin the rules.

// Pragmatic email check — not full RFC 5322 (impractical, rejects nothing
// real). The backend re-validates and real deliverability is proven by the
// confirmation click on the news list.
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Returns { ok: true, name, email } with trimmed values, or
// { ok: false, error } with a user-facing message. Tolerant on names (unicode,
// hyphens, apostrophes all fine) — only emptiness + length are enforced.
export function validateNameEmail(name, email) {
  const trimmedName = (name || '').trim();
  const trimmedEmail = (email || '').trim();

  if (!trimmedName) return { ok: false, error: 'Please enter your name.' };
  if (trimmedName.length > 100) return { ok: false, error: 'Please enter a shorter name.' };
  if (!EMAIL_REGEX.test(trimmedEmail) || trimmedEmail.length > 254) {
    return { ok: false, error: 'Please enter a valid email address.' };
  }
  return { ok: true, name: trimmedName, email: trimmedEmail };
}

// Shared input styling (white field, blue accent) — reads well on both the
// light Home hero (#D1DEE6) and the News card palette.
export const SIGNUP_INPUT_STYLE = {
  backgroundColor: '#FFFFFF',
  color: '#2B1E19',
  padding: '14px',
  borderRadius: '12px',
  border: '1px solid #4A8EB3',
  width: '280px',
  maxWidth: '100%',
  textAlign: 'center',
  fontSize: '16px',
  outline: 'none',
  fontFamily: 'Inter, sans-serif',
  boxSizing: 'border-box',
};
